import { Page, PageContent } from '../model/page';
import { CMS_PAGES } from '../../adapters/secondary/content/cmsPageRepository';
import { Language } from '../../shared/constants/routes';

/**
 * Everything the application asks about pages built in the editing system.
 *
 * Components, the router and the prerenderer all come through here rather than
 * reading page files themselves - the same arrangement ContentUseCase provides
 * for the hand-written pages. Where the pages are stored, and in what shape,
 * stays a question only the repository has to answer.
 */
export class PageUseCase {
  /** Every published page, in file-name order. */
  getPages(): Page[] {
    return CMS_PAGES;
  }

  getPage(slug: string): Page | undefined {
    return CMS_PAGES.find((page) => page.slug === slug);
  }

  getPageByPath(path: string): Page | undefined {
    return CMS_PAGES.find((page) => page.path === path);
  }

  /** Whether a path belongs to a page from the editing system. */
  isPagePath(path: string): boolean {
    return this.getPageByPath(path) !== undefined;
  }

  getContent(slug: string, language: Language): PageContent | undefined {
    return this.getPage(slug)?.content[language];
  }

  /** Menu entries for the pages an editor marked as belonging in the menu. */
  getNavItems(language: Language): Array<{ path: string; label: string }> {
    return CMS_PAGES.filter((page) => page.showInNav).map((page) => ({
      path: page.path,
      label: page.content[language].navLabel,
    }));
  }
}
